export default __webpack_public_path__ + "static/media/NATA-Logo.dc3160b5.svg";